import React from "react";
import { Terminal } from "lucide-react";
import { timeHM } from "../../lib/format";

const DOT = {
  error: "bg-rose-400",
  warning: "bg-amber-400",
  info: "bg-sky-400",
};

export default function ActivityLog({ snapshot }) {
  const events = snapshot?.events || [];
  return (
    <div id="log-operazioni" data-testid="operations-activity-log-feed" className="panel overflow-hidden float-in">
      <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
        <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
          <span className="w-6 h-6 rounded-md grid place-items-center bg-slate-500/15 text-slate-300">
            <Terminal size={13} />
          </span>
          Log Operazioni
        </div>
        <span className="text-[10px] text-slate-500 font-mono">{events.length} eventi</span>
      </div>
      <div className="px-5 max-h-[360px] overflow-y-auto">
        {events.length === 0 ? (
          <div className="text-[11px] text-slate-500 text-center py-8">Nessun evento ricevuto</div>
        ) : (
          events.map((e) => (
            <div key={e.id} className="flex gap-3 py-3 border-b border-white/8 last:border-0">
              <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${DOT[e.type] || DOT.info}`} />
              <div className="flex-1 min-w-0">
                <div className="text-[11px] text-slate-200 leading-snug">{e.message}</div>
                <div className="text-[10px] text-slate-500 mt-0.5">Signal engine · bridge monitor</div>
              </div>
              <span className="text-[10px] text-slate-500 font-mono shrink-0">{timeHM(e.at)}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
